import { Controller } from '@hotwired/stimulus'
import PrimeVue from 'primevue/config'
import Tailwind from 'primevue/passthrough/tailwind'
import InputText from 'primevue/inputtext'
import Dropdown from 'primevue/dropdown'
import Calendar from 'primevue/calendar'
import Button from 'primevue/button'
import Checkbox from 'primevue/checkbox'
import Textarea from 'primevue/textarea'

import 'vue-loading-overlay/dist/css/index.css'
import 'primeicons/primeicons.css'
import Dialog from 'primevue/dialog'
import { createApp } from 'vue'
import axios from 'axios'
import RentalRoomEntryEditFrom from '../components/RentalRoomEntryEditForm.vue'

axios.defaults.headers.common['X-CSRF-Token'] = document
  .querySelector('meta[name="csrf-token"]')
  .getAttribute('content')
export default class extends Controller {
  static targets = ['dialogButton']
  static values = {
    entry: Object,
    rooms: Array,
    workers: Array,
    designationTypes: Array,
    rentalServices: Array,
    currentUserId: Number
  }

  connect () {
    const app = createApp(RentalRoomEntryEditFrom,
      {
        entry: this.entryValue,
        rooms: this.roomsValue,
        workers: this.workersValue,
        designationTypes: this.designationTypesValue,
        rentalServices: this.rentalServicesValue,
        currentUserId: this.currentUserIdValue
      })
    app.use(PrimeVue, {
      unstyled: true,
      pt: Tailwind,
      locale: {
        accept: 'はい',
        reject: 'いいえ',
        choose: '選択',
        upload: 'アップロード',
        cancel: 'キャンセル',
        dayNames: ['日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日'],
        dayNamesShort: ['日', '月', '火', '水', '木', '金', '土'],
        dayNamesMin: ['日', '月', '火', '水', '木', '金', '土'],
        monthNames: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
        monthNamesShort: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
        today: '今日',
        clear: 'クリア',
        weekHeader: '週',
        firstDayOfWeek: 0,
        dateFormat: 'yy/mm/dd',
        weak: '弱い',
        medium: '普通',
        strong: '強い',
        passwordPrompt: 'パスワードを入力'
      }
    })
    app.component('Dialog', Dialog)
    app.component('InputText', InputText)
    app.component('Dropdown', Dropdown)
    app.component('Calendar', Calendar)
    app.component('Button', Button)
    app.component('Checkbox', Checkbox)
    app.component('Textarea', Textarea)
    app.mount(this.dialogButtonTarget)
  }
}
